import * as React from "react";
import { Redirect } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Elements, StripeProvider } from "react-stripe-elements";
import "react-toastify/dist/ReactToastify.css";
import { Online, Offline } from "react-detect-offline";
import { FormGroup } from "reactstrap";
import CheckoutForm from "./checkoutForm.Component";
import Navbar from "../../components/CustomNav/CustomNav.Component";
import "./checkoutPages.css";
import countries from "../../assets/data/countries";
import Loader from "react-loader";
import CustomCheckbox from "../../common/CustomCheckbox";

// services
import {
  getGeneralSmartTableDataNoAuth,
  signupJson,
  getStripeKey
} from "../../common/services";

export default class CheckoutWebinar extends React.Component {
  public state = {
    signin: true, // first form to show, toggle to move to payment form
    signinSuccess: false,
    paymentSuccess: false,
    countries: [] as any[],
    amount: 99,
    loading: true,
    Processing: false,
    email: "",
    firstname: "",
    lastname: "",
    profile: "students",
    username: "",
    date: "",
    password: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    postalcode: "",
    monthlyamount: 30,
    toLogin: false,
    p_firstname: "",
    p_lastname: ""
  };
  constructor(props) {
    super(props);
    this.togglePaymentState = this.togglePaymentState.bind(this);
    this.signUpForm = this.signUpForm.bind(this);
    // this.paymentForm = this.paymentForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.signUpSubmit = this.signUpSubmit.bind(this);
    this.isSignupFilled = this.isSignupFilled.bind(this);
    this.handleGenCreatedItemLoaded = this.handleGenCreatedItemLoaded.bind(
      this
    );
    this.handleCountriesLoaded = this.handleCountriesLoaded.bind(this);
    this.StartProcessing = this.StartProcessing.bind(this);
    this.goToLogin = this.goToLogin.bind(this);
  }

  public async componentDidMount() {
    // leo stuff
    getGeneralSmartTableDataNoAuth("admin/countries/overview_items/", text =>
      this.handleCountriesLoaded(text)
    );
  }

  public handleCountriesLoaded(res) {
    console.log("res loaded");
    console.log(res);
    if (res.code === 200) {
      console.log("ok");
      this.setState({ countries: res.response.countries, loading: false });
    } else {
      toast.error("Unable to load countries list");
    }
  }

  public togglePaymentState() {
    this.setState({ paymentSuccess: true });
  }

  public goToLogin() {
    this.setState({ toLogin: true });
  }

  public handleGenCreatedItemLoaded(res) {
    if (res.code === 200) {
      toast.success("Request successful");

      setTimeout(this.goToLogin, 900);
    } else {
      toast.error("Request failed, try again");
    }

    this.setState({ Processing: false });
  }

  public StartProcessing() {
    this.setState({ Processing: true });
  }

  public signUpSubmit = token => {
    // sign up form target values
    // toggle signup to false on success
    // evt.preventDefault()

    console.log("submission ongoing..");
    console.log(token);
    if (!token) {
      toast.error("Error Processing Card");
    }

    const item = {
      Amount: this.state.monthlyamount,
      SingleAmount: this.state.amount,
      Token: token,
      Username: this.state.username,
      Password: this.state.password,
      FirstName: this.state.firstname,
      LastName: this.state.lastname,
      Email: this.state.email,
      Country: this.state.country,
      PostalCode: this.state.postalcode,
      ParentFirstName: this.state.p_firstname,
      ParentLastName: this.state.p_lastname,
      Address: this.state.address,
      City: this.state.city,
      Phone: this.state.phone,
      Profile: this.state.profile,
      Birthday: this.state.date
    };

    signupJson("admin/users/register_checkout_website_webinar/", item, text =>
      this.handleGenCreatedItemLoaded(text)
    );
  };

  public isSignupFilled() {
    if (
      this.state.address.length < 1 ||
      this.state.city.length < 1 ||
      this.state.email.length < 1 ||
      this.state.country.length < 1 ||
      this.state.date.length < 1
    ) {
      toast.warn("Please fill in all fields");
      return false;
    } else {
      return true;
    }
  }

  public handleChange = event => {
    // form fields onchange
    const valnm = event.currentTarget.dataset.arg;
    console.log(valnm);
    // this.state[valnm] = event.target.value;
    this.setState({ [valnm]: event.target.value });
    console.log(this.state.amount);
  };

  public signUpForm() {
    return (
      <form id="checkout-form" noValidate={false} onSubmit={this.signUpSubmit}>
        <Loader color="#3EE9F7" loaded={!this.state.loading}>
          <div className="checkout-form-container">
            {/* parent names */}
            <div className="checkout-input-holder">
              <div className="input-item-wrapper">
                <span className="input-label">Parent First Name</span>

                <input
                  id="p_firstname"
                  className="custom-textfield checkout-input"
                  type="text"
                  placeholder="First Name"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="p_firstname"
                />
              </div>

              <div className="input-item-wrapper">
                <span className="input-label">Parent Last Name</span>
                <input
                  id="p_lastname"
                  className="custom-textfield checkout-input"
                  type="text"
                  placeholder="Last Name"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="p_lastname"
                />
              </div>
            </div>

            {/* Email */}
            <div className="input-item-wrapper">
              <span className="input-label">Parent Email</span>
              <input
                id="email"
                className="custom-textfield checkout-input"
                type="email"
                placeholder="Enter Email"
                onChange={this.handleChange}
                required={true}
                data-arg="email"
              />
            </div>

            {/* child names */}
            <div className="checkout-input-holder">
              <div className="input-item-wrapper">
                <span className="input-label">Child First Name</span>
                <input
                  id="firstname"
                  className="custom-textfield checkout-input"
                  type="text"
                  placeholder="First Name"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="firstname"
                />
              </div>
              <div className="input-item-wrapper">
                <span className="input-label">Child Last Name</span>
                <input
                  id="lastname"
                  className="custom-textfield checkout-input"
                  type="text"
                  placeholder="Last Name"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="lastname"
                />
              </div>
            </div>

            <div className="input-item-wrapper">
              <span className="input-label">Child Date of Birth</span>
              <input
                id="date"
                type="date"
                className="custom-datepicker checkout-input"
                name="Birthday"
                required={true}
                defaultValue="2005-05-24"
                data-arg="date"
                onChange={this.handleChange}
              />
            </div>

            <div className="checkout-input-holder">
              <div className="input-item-wrapper">
                <span className="input-label">Parent Phone</span>
                <input
                  id="phone"
                  className="custom-textfield checkout-input"
                  type="tel"
                  placeholder="Phone Number"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="phone"
                />
              </div>
              <div className="input-item-wrapper">
                <span className="input-label">Address 1</span>
                <input
                  id="address"
                  className="custom-textfield checkout-input"
                  type="text"
                  placeholder="Address 1"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="address"
                />
              </div>
            </div>

            <div className="checkout-input-holder">
              <div className="input-item-wrapper">
                <span className="input-label">Address 2 (Optional)</span>
                <input
                  id="address2"
                  className="custom-textfield checkout-input"
                  type="text"
                  placeholder="Address 2 (Optional)"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="address2"
                />
              </div>
              <div className="input-item-wrapper">
                <span className="input-label">Postal Code/Zip Code</span>
                <input
                  id="postal-code"
                  className="custom-textfield checkout-input"
                  type="text"
                  placeholder="Postal Code/Zip Code"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="postalcode"
                />
              </div>
            </div>
            {/*end phone + address*/}
            {/* zipcode + city */}
            <div className="checkout-input-holder">
              <div className="input-item-wrapper">
                <span className="input-label">City</span>
                <input
                  id="city"
                  className="custom-textfield checkout-input"
                  type="text"
                  placeholder="City"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="city"
                />
              </div>
              <div className="input-item-wrapper">
                <span className="input-label">State/Province</span>
                <input
                  id="state"
                  className="custom-textfield checkout-input"
                  type="text"
                  placeholder="State/Province"
                  onChange={this.handleChange}
                  required={true}
                  data-arg="state"
                />
              </div>
            </div>

            <div className="input-item-wrapper">
              <span className="input-label">Country</span>
              <select
                name="country"
                id="country"
                className="custom-select checkout-input"
                required={true}
                data-arg="country"
                value={this.state.country}
                onChange={this.handleChange}
              >
                <option>Country</option>

                {this.state.countries.map((c) => (
                  <option value={c.id}> {c.Name}</option>
                ))}
              </select>
            </div>
            <div className="checkout-items">
              <h2 className="checkout-total">Billing Plan</h2>
              <div className="checkout-breakdown">
                <p className="checkout-item-name">
                  <span>&pound;{this.state.amount}</span> for the assessment and
                  <span> 45-min coaching call </span>
                  following on with a <span>14-day FREE trial</span> of
                  Performance Learning, billed at{" "}
                  <span>&pound;{this.state.monthlyamount} p.m.</span> once your
                  trial is over (billed annually)
                </p>
              </div>
            </div>

            <Loader color="#3EE9F7" loaded={!this.state.Processing} />

            <StripeProvider apiKey={getStripeKey()}>
              <div className="stripe-elems">
                <h2 className="payment-title">payment information</h2>
                <Elements>
                  <CheckoutForm
                    togglePaymentState={this.togglePaymentState}
                    amount={this.state.amount}
                    onSuccess={this.signUpSubmit}
                    formFilled={this.isSignupFilled}
                    StartProcessing={this.StartProcessing}
                  />
                </Elements>
              </div>
            </StripeProvider>

            <FormGroup className="landing-form-grp">
              <p className="checkout-terms">
                <span>
                  <a
                    href="https://myperformancelearning.com/terms-of-service/"
                    target="_blank"
                  >
                    Terms of Use
                  </a>
                </span>
                <span>
                  <a
                    href="https://myperformancelearning.com/privacy-policy/"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>
                </span>
                <span>
                  <a
                    href="https://myperformancelearning.com/cookie-policy/"
                    target="_blank"
                  >
                    Cookie Policy
                  </a>
                </span>
                .
              </p>
              <br />
              <Offline>
                <i className="fa fa-bell">You are currently offline</i>
              </Offline>
            </FormGroup>
          </div>
        </Loader>
      </form>
    );
  }

  public render() {
    if (this.state.toLogin === true) {
      return <Redirect to="/login" />;
    }
    return (
      <div className="checkout-body">
        <Navbar />
        <div className="checkout-banner">
          <ToastContainer />
          <p className="banner-message">
            In 2019 we are committed to helping at least 20,000 students to
            reach their true potential by equipping them with the skills they
            need to succeed in and outside of school
          </p>
          <span />
        </div>
        <div className="checkout-container">{this.signUpForm()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Subscription/checkoutWebinar.Component.tsx